export default "__VITE_ASSET__CNC7wzw0__"